import { OPTIONS_URA } from 'app-constants'
import { http } from 'hooks'

export function uraService() {
  function sendUraEvaluation(data) {
    return http.post('/avaliacao', data, OPTIONS_URA)
  }

  function getUraEvaluationProtocol(data) {
    return http.get(`/avaliacao/${data}`, OPTIONS_URA)
  }

  function getUraProtocol(data) {
    return http.get(`/protocolo/${data}`, OPTIONS_URA)
  }
  return {
    sendUraEvaluation,
    getUraEvaluationProtocol,
    getUraProtocol,
  }
}
